
/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ClientCompanyBillingInfoParam,
  ClientCompanyBillingInfoResource,
  ClientCompanyMembersListResource,
  ClientCompanySourcingHubContextResource,
  ValidationError,
} from '../models';
import {
    ClientCompanyBillingInfoParamFromJSON,
    ClientCompanyBillingInfoParamToJSON,
    ClientCompanyBillingInfoResourceFromJSON,
    ClientCompanyBillingInfoResourceToJSON,
    ClientCompanyMembersListResourceFromJSON,
    ClientCompanyMembersListResourceToJSON,
    ClientCompanySourcingHubContextResourceFromJSON,
    ClientCompanySourcingHubContextResourceToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface GetClientCompanyBillingInfoRequest {
    companyId: string;
}

export interface GetClientCompanyMembersRequest {
    companyId: string;
    role?: GetClientCompanyMembersRoleEnum;
}

export interface GetClientCompanySourcingHubContextRequest {
    companyId: string;
}

export interface PostClientCompanyBillingInfoRequest {
    companyId: string;
    clientCompanyBillingInfoParam: ClientCompanyBillingInfoParam;
}

/**
 * 
 */
export class ClientCompanyApi extends runtime.BaseAPI {

    /**
     * Acknowledge Job Description Modal
          */
    async acknowledgeJobDescRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/project-client/api/acknowledge/job-desc`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Acknowledge Job Description Modal
          */
    async acknowledgeJobDesc(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acknowledgeJobDescRaw(initOverrides);
    }

    /**
     * Acknowledge Post A Project Onboarding Modal
          */
    async acknowledgePostAProjectOnboardingRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/project-client/api/acknowledge/post-a-project-onboarding`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Acknowledge Post A Project Onboarding Modal
          */
    async acknowledgePostAProjectOnboarding(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acknowledgePostAProjectOnboardingRaw(initOverrides);
    }

    /**
     * Acknowledge Search Onboarding Modal
          */
    async acknowledgeSearchOnboardingRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/project-client/api/acknowledge/search-onboarding`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Acknowledge Search Onboarding Modal
          */
    async acknowledgeSearchOnboarding(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acknowledgeSearchOnboardingRaw(initOverrides);
    }

    /**
     * Fetch the client company billing contact information
          */
    async getClientCompanyBillingInfoRaw(requestParameters: GetClientCompanyBillingInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientCompanyBillingInfoResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getClientCompanyBillingInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientCompanyBillingInfoResource>({
            path: `/project-client/api/company/{companyId}/billing-info`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientCompanyBillingInfoResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch the client company billing contact information
          */
    async getClientCompanyBillingInfo(requestParameters: GetClientCompanyBillingInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientCompanyBillingInfoResource> {
        const response = await this.getClientCompanyBillingInfoRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get all the company client members of the company
          */
    async getClientCompanyMembersRaw(requestParameters: GetClientCompanyMembersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientCompanyMembersListResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getClientCompanyMembers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientCompanyMembersListResource>({
            path: `/project-client/api/company/{companyId}/members`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientCompanyMembersListResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get all the company client members of the company
          */
    async getClientCompanyMembers(requestParameters: GetClientCompanyMembersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientCompanyMembersListResource> {
        const response = await this.getClientCompanyMembersRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Fetch the client company context sourcing hub context
          */
    async getClientCompanySourcingHubContextRaw(requestParameters: GetClientCompanySourcingHubContextRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientCompanySourcingHubContextResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getClientCompanySourcingHubContext().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientCompanySourcingHubContextResource>({
            path: `/project-client/api/company/{companyId}/find-freelancer-context`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientCompanySourcingHubContextResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch the client company context sourcing hub context
          */
    async getClientCompanySourcingHubContext(requestParameters: GetClientCompanySourcingHubContextRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientCompanySourcingHubContextResource> {
        const response = await this.getClientCompanySourcingHubContextRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update the company billing contact information
          */
    async postClientCompanyBillingInfoRaw(requestParameters: PostClientCompanyBillingInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientCompanyBillingInfoResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling postClientCompanyBillingInfo().'
            );
        }

        if (requestParameters['clientCompanyBillingInfoParam'] == null) {
            throw new runtime.RequiredError(
                'clientCompanyBillingInfoParam',
                'Required parameter "clientCompanyBillingInfoParam" was null or undefined when calling postClientCompanyBillingInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ClientCompanyBillingInfoResource>({
            path: `/project-client/api/company/{companyId}/billing-info`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientCompanyBillingInfoParamToJSON(requestParameters['clientCompanyBillingInfoParam']),
        }, initOverrides);

        if (response._data) { response._data=ClientCompanyBillingInfoResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Update the company billing contact information
          */
    async postClientCompanyBillingInfo(requestParameters: PostClientCompanyBillingInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientCompanyBillingInfoResource> {
        const response = await this.postClientCompanyBillingInfoRaw(requestParameters, initOverrides);
        return response._data;
    }

}

/**
 * @export
 */
export const GetClientCompanyMembersRoleEnum = {
    All: 'ALL',
    Member: 'MEMBER',
    Admin: 'ADMIN'
} as const;
export type GetClientCompanyMembersRoleEnum = typeof GetClientCompanyMembersRoleEnum[keyof typeof GetClientCompanyMembersRoleEnum];
